<template>
  <div>
    <mdb-list-group v-bind:key="event.id" v-for="event in listData">
      <mdb-list-group-item :class="event.topPin ? 'list-group-item-top-pin' : ''">
        <event-summary :event="event" :mode="mode"/>
      </mdb-list-group-item>
    </mdb-list-group>
    <div v-if="listData.length == 0">
      Nothing to show at this time.
    </div>
      <mdb-pagination circle v-if="pagination && pages>1">
        <mdb-page-item @click.native="navTo(1)" v-if="pages > 10 && pageRange[0] != 1">First</mdb-page-item>
        <mdb-page-nav prev @click.native="navPrev" v-if="currentPage > 1"></mdb-page-nav>
        <mdb-page-item :active="n == currentPage" @click.native="navTo(n)" v-bind:key="n" v-for="n in pageRange">{{n}}
        </mdb-page-item>
        <mdb-page-nav next v-if="currentPage < pages" @click.native="navNext"></mdb-page-nav>
        <mdb-page-item @click.native="navTo(pages)" v-if="pages > 10 && pageRange[9] != pages">Last</mdb-page-item>

      </mdb-pagination>
  </div>
</template>

<script>
import eventSummary from './Summary'
import {mdbContainer, mdbListGroup, mdbListGroupItem, mdbPageItem, mdbPageNav, mdbPagination} from 'mdbvue';

export default {
    name: 'eventList',
    components: {
      mdbContainer,
      mdbListGroup,
      mdbListGroupItem,
      mdbPagination,
      mdbPageItem,
      mdbPageNav,
      eventSummary
    },
    props: {
      mode: {
          type: String,
          default: ""
      },
      listData: {
        type: Array,
        default: null
      },
      pagination: {
        type: Boolean,
        default: false
      },
      totalCount: {
        type: Number,
        default: null
      },
      maxPerPage: {
        type: Number,
        default: 25
      }
    },
    data() {
      return {
        pageRange: [],
        pages: 0,
        currentPage: 1
      }
    },
    watch: {
      listData: function (n, o) {
        this.calculatePagination()
      }
    },
    mounted() {
      this.calculatePagination()
    },
    methods: {
      navNext: function() {
        let jumpTo = this.currentPage + 1
        if (this.currentPage + 10 < this.pages) jumpTo = this.currentPage + 10
        this.navTo(jumpTo)
      },
      navPrev: function() {
        let jumpTo = this.currentPage - 1
        if (this.currentPage - 10 > 0) jumpTo = this.currentPage - 10
        this.navTo(jumpTo)
      },
      navTo: function (n) {
        this.currentPage = n
        let offset = (n - 1) * 25
        this.$emit("loadMore", offset)
        window.scrollTo(0, 0)
      },
      calculatePagination: function () {
        if (this.pages == 1) return
        this.pageRange = []
        if (this.totalCount <= this.maxPerPage) this.pages = 1
        else {
          this.pages = Math.round(this.totalCount / this.maxPerPage)
          if ((this.pages * 25) < this.totalCount) this.pages++
        }
        let rangeStart = 0
        if (this.pages <= 10) {
          rangeStart = 1
        } else {
          rangeStart = this.currentPage - 1
          if (rangeStart + 10 > this.pages) rangeStart = this.pages - 9
        }
        if (rangeStart < 1) rangeStart = 1
        let max = (this.pages > 10 ? 10 : this.pages)
        for (let i = 0; i < max; i++) {
          const p = i + rangeStart
          if (p <= this.pages) this.pageRange.push(p)
        }
      }
    }
  };
</script>

<style scoped>
  .list-group-item-top-pin {
      border: 5px solid var(--secondary);
      margin: 15px 0 15px 0;
  }
</style>
